import * as React from "react";
import styled from "styled-components";

import Modal, { Prompt, ModalFooter } from "@ingka/modal";
import Button from "@ingka/button";

import { StyledModalHeader } from "../styles";
import { MarketName } from "./utils";
import SelectMarkets from "../SelectMarkets/SelectMarkets";

const StyledPrompt = styled(Prompt)`
	width: 30rem;
	.prompt__content {
		overflow: unset;
	}
`;

interface CopyMarketValueModalProps {
	showModal: boolean;
	setShowModal: (value: boolean) => void;
	marketNameFromData?: MarketName[];
	marketsNameToData?: MarketName[];
	selectedMarketCopyValueFrom: string;
	setSelectedMarketCopyValueFrom: (value: string) => void;
	selectedMarketsCopyValueTo: string[];
	setSelectedMarketsCopyValueTo: (value: string[]) => void;
	onCopyMarketValues: () => void;
	copyingMarketValues: boolean;
}

const CopyMarketValueModal: React.FC<CopyMarketValueModalProps> = ({
	showModal,
	setShowModal,
	marketNameFromData,
	marketsNameToData,
	selectedMarketCopyValueFrom,
	setSelectedMarketCopyValueFrom,
	selectedMarketsCopyValueTo,
	setSelectedMarketsCopyValueTo,
	onCopyMarketValues,
	copyingMarketValues,
}) => {
	return (
		<Modal
			visible={showModal}
			escapable={true}
			handleCloseBtn={() => {
				setShowModal(false);
				setSelectedMarketCopyValueFrom("");
				setSelectedMarketsCopyValueTo([]);
			}}
		>
			<StyledPrompt
				title="Copy Market Values"
				titleId="modalTitleId"
				header={<StyledModalHeader id="copy-values-modal-header" />}
				footer={
					<ModalFooter>
						<Button
							data-testid="copyvaluesbutton"
							text="Copy values"
							loading={copyingMarketValues}
							disabled={!selectedMarketCopyValueFrom || selectedMarketsCopyValueTo.length === 0}
							type="emphasised"
							onClick={() => onCopyMarketValues()}
						/>
					</ModalFooter>
				}
			>
				<>
					<SelectMarkets
						id="copy-from-market"
						label="Select Market from"
						helperText="Choose the market from which you would like to transfer the value."
						marketsData={marketNameFromData}
						selected={selectedMarketCopyValueFrom}
						multiple={false}
						onChange={(values) => setSelectedMarketCopyValueFrom(values[0])}
					/>

					<SelectMarkets
						id="copy-to-market"
						label="Select Market to"
						helperText="Choose the market to which you would like to transfer the value"
						marketsData={marketsNameToData}
						selected={selectedMarketsCopyValueTo}
						onChange={setSelectedMarketsCopyValueTo}
					/>
				</>
			</StyledPrompt>
		</Modal>
	);
};

export default CopyMarketValueModal;
